<style lang="scss" scoped>
// .equ {
//   position: absolute;
//   width: 415px;
//   height: 201px;
//   right: 1px;
//   top: 219px;
//   background-image: url("../../../../../assets/pagesImg/water-supply.png");
// }
.equ {
  width: 415px;
  height: 200px;
  margin-top: 20px;
  cursor: pointer;
  .drainage {
    margin-top: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-evenly;
    .data {
      height: 92px;
      font-size: 18px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .number {
        font-size: 48px;
        font-family: "dina";
      }
    }
    .data:nth-child(1) {
      .number {
        color: #2d82ff;
      }
    }
    .data:nth-child(3) {
      .number {
        color: #f1802f;
      }
    }
  }
}
</style>

<template>
  <div class="equ" @click="to('/watersupply')">
    <custom-plane
      title="给排水系统"
      :iconImg="require('@/assets/compImg/EquipmentIcon/gps.png')"
    >
      <div class="drainage">
        <div v-for="(item, index) in drainageList" :key="index" class="data">
          <p>{{ item.title }}</p>
          <p class="number">{{ item.num }}</p>
        </div>
      </div>
    </custom-plane>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    drainageList: Array,
  },
  methods: {
    to(path) {
      this.$router.push({ path });
    },
  },
};
</script>
